import { createContext } from "react";

import useActionReducer from "../util/useActionReducer";

export const DesktopNotificationPopupContext = createContext<PopupNotification[] | undefined>(undefined);
export const DesktopNotificationPopupDispatchContext = createContext<any | undefined>(undefined);

export function DesktopNotificationPopupProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [state, dispatch] = useActionReducer(popupNotificationActions, {popup: []});

  return (
    <DesktopNotificationPopupContext.Provider value={state.popup}>
      <DesktopNotificationPopupDispatchContext.Provider value={dispatch}>
        { children }
      </DesktopNotificationPopupDispatchContext.Provider>
    </DesktopNotificationPopupContext.Provider>
  )
}

type UWEEntity = any;
type Workflow = any;

export type PopupNotification = {
  id: number,
  subject?: string,
  message?: string,
  cleared?: boolean,
  link: string,
  notificationType: string,
  uweEntity: UWEEntity , // incomplete type
  workflow: Workflow
};

export type NotificationsState = {
  popup: PopupNotification[];
}


// A data structure holding open notifications with helpers to modify it
const popupNotificationActions = {
  update: (notifs: PopupNotification[], { popup: prev }: NotificationsState) => {
    const open = new Set(prev.map((n) => n.id));
    const toAdd = [];

    for (const n of notifs) {
      if (!open.has(n.id)) {
        toAdd.push(n);
      }
    }

    return { popup: [...prev, ...toAdd]};
  },
  push: (n: PopupNotification, { popup: prevItems }: NotificationsState) => ({
    popup: [...prevItems, n]
  }),
  pop: (n: PopupNotification, { popup: prev }: NotificationsState) => ({
    popup: prev.filter(i => i.id !== n.id)
  })
};
